export class MyHardCopyConstants {

  
  public static readonly MyHardCopyActivity_Completed_Success:string = "Hardcopy Activity Completed Successfully";
  public static readonly Severity_Info:string = "success";
    
  // Constants
  public static readonly MyHardCopyTitle = 'My Hardcopy Activities';
}
